import { useEffect } from "react";
import { useFormik } from "formik";
import PlacingSlipFilePicker from "./placing-slip-file-picker";
import StepFooter from "./step-footer";

type Props = {
    handleNext: (_values: any) => void;
    handlePrevious: () => void;
    handleCancel: () => void;
    initialValues: any;
    parentForm?: any;
};

const PlacingSlipForm = ({
    handleCancel,
    handleNext,
    initialValues,
    handlePrevious,
    parentForm,
}: Props) => {
    const form = useFormik<any>({
        initialValues: {
            pendingFiles: initialValues?.pendingFiles || [],
            hasExisting: false,
        },
        onSubmit: (values) => {
            syncParent(values.pendingFiles || []);
            handleNext(values);
        },
        onReset: () => {
            handleCancel();
        },
    });

    const syncParent = (pendingFiles: File[]) => {
        parentForm?.setFieldValue("placingSlip", {
            pendingFiles,
            hasExisting: false,
        });
    };

    useEffect(() => {
        form.setValues({
            pendingFiles: initialValues?.pendingFiles || [],
            hasExisting: initialValues?.hasExisting || false,
        });
    }, [initialValues]);

    return (
        <div className="flex-1 flex flex-col overflow-hidden">
            <form
                onSubmit={form.handleSubmit}
                className="space-y-6 divide-y divide-gray-200 overflow-y-auto flex-1">
                <div className="p-6 space-y-4">
                    <div>
                        <h3 className="text-sm font-medium text-gray-900 dark:text-gray-100">
                            Upload Placing Slip
                        </h3>
                        <p className="mt-1 text-xs text-gray-500">
                            Select the placing slip document for this offer. It
                            will be uploaded when you submit the offer.
                        </p>
                    </div>
                    <PlacingSlipFilePicker
                        files={form.values.pendingFiles}
                        onChange={(files) => {
                            form.setFieldValue("pendingFiles", files);
                            syncParent(files);
                        }}
                    />
                </div>
            </form>
            <StepFooter
                onNext={form.handleSubmit}
                onCancel={form.resetForm}
                onPrevious={handlePrevious}
                showPrevious={true}
            />
        </div>
    );
};

export default PlacingSlipForm;
